import React from 'react';
import '../styles.module.scss'
import PropTypes from "prop-types";
import isEmpty from 'lodash/isEmpty'
import InfoTooltip from '../../utility/InfoTooltip'

const ProviderMatchingCriteria = ({provider}) => {
  const { id, cqs_attributes } = provider;
  const {
    profile_modalities,
    service_specialty,
    license_geographical_coverage,
    tpns,
    requester_age_brackets,
    geographic_reach,
    languages,
    pediatrics,
    affiliation
  } = cqs_attributes;
  return <div>
    <h1>Provider Matching Criteria</h1>
    <p>Provider ID: {id}</p>
    { !isEmpty(cqs_attributes) ? <div>
      <div className="providers-container border-1 border-message-primary">
        <header className="bg-message-primary text-white p-2">
          <p>Absolute Criteria</p>
          <p>Used to determine the subset of consults a provider is eligible to service</p>
        </header>
        <section className="p-2">
          <div>
            <div>
              <strong className="pr-1">Supported Modality</strong>
              <InfoTooltip id="modality" info="The providers ability to connect via phone or also via video. It does not define whether and how the provider is currently clocked in"/>
            </div>
            <ul className="list-none p-0" id="profile_modalities">
              {profile_modalities.map(modality => <li key={modality}>{modality}</li>)}
            </ul>
          </div>
          <div>
            <strong className="pr-1" >Service Specialty</strong>
            <div id="service_specialty" id="service_specialty">{service_specialty}</div>
          </div>
          <div>
            <div>
              <strong className="pr-1">License Location (includes Open-State Licenses)</strong>
              <InfoTooltip id="license" info="The location (state), for which the provider is licensed to conduct consults. Includes open-state licenses, if the provider opted into the open-state option"/>
            </div>
            <div id="license_geographical_coverage">
              {license_geographical_coverage.join(', ')}
            </div>
          </div>
          <div>
            <div>
              <strong className="pr-1">TPN</strong>
              <InfoTooltip id="tpn" info="Teladoc Provider Networks (TPNs) are grouping of providers"/>
            </div>
            <ul className="list-none p-0" id="tpns">
              {tpns.map(tpn => <li key={tpn}>{tpn}</li>)}
            </ul>
          </div>
          <div>
            <div>
              <strong className="pr-1">Age Bracket</strong>
              <InfoTooltip id="age" info="Age brackets are: Toddler (T) 0-2 years, Youngster (Y) 3-17 years, Young Adult (YA) 18-21 years, and Adult (A) 22 years and older"/>
            </div>
            <ul className="list-none p-0" id="requester_age_brackets">
              {requester_age_brackets.map(ageBracket => <li key={ageBracket}>{ageBracket}</li>)}
            </ul>
          </div>
          <div>
            <div>
              <strong className="pr-1">Geographic Reach</strong>
              <InfoTooltip id="geographic" info="True if the provider is qualified to consuct global care consults"/>
            </div>
            <ul className="list-none p-0" id="geographic_reach">
              {geographic_reach.map(methods => <li key={methods}>{methods}</li>)}
            </ul>
          </div>
        </section>
      </div>
      <div className="providers-container border-1 border-message-primary mt-3">
        <header className="bg-message-primary text-white p-2">
          <p>Preference Criteria</p>
          <p>Used to determine the priority of this provider relative to other eligible providers, when assigning consults</p>
        </header>
        <section className="p-2">
          <div>
            <div>
              <strong className="pr-1">Language</strong>
              <InfoTooltip id="languages-tooltip" info="Languages the provider speaks"/>
            </div>
            <ul className="list-none p-0" id="languages">
              {languages.map(language => <li key={language}>{language}</li>)}
            </ul>
          </div>
          <div>
            <div>
              <strong className="pr-1">Pediatrics</strong>
              <InfoTooltip id="pediatrics-tooltip" info="Providers with pediatrics qualification are given preference for members in the Toddler and Youngster age brackets"/>
            </div>
            <div id="pediatrics">{pediatrics.toString().toUpperCase()}</div>
          </div>
          <div>
            <div>
              <strong className="pr-1">Affiliation</strong>
              <InfoTooltip id="affiliation-tooltip" info="The business affiliation providers have with Teladoc"/>
            </div>
            <div id="affiliation">{affiliation}</div>
          </div>
        </section>
      </div>
    </div> : <p>
      No matching criteria are found.
    </p>}
  </div>
}

ProviderMatchingCriteria.propTypes = {
  provider: PropTypes.shape({
    id: PropTypes.number,
    cqs_attributes: PropTypes.shape({
      profile_modalities: PropTypes.array,
      service_specialty: PropTypes.string,
      license_geographical_coverage: PropTypes.array,
      tpns: PropTypes.array,
      requester_age_brackets: PropTypes.array,
      geographic_reach: PropTypes.array,
      languages: PropTypes.array,
      pediatrics: PropTypes.bool,
      affiliation: PropTypes.string
    })
  })
};

export default ProviderMatchingCriteria
